export const recommendedMarginTooltips = (_serviceId, isCart = false) => {
  return `相場変動リスクを考慮した運用資金の目安${isCart ? 'の合計' : ''}。`;
};
